import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';
import FListFooter, { listStateAndListMore } from '@/components/FListFooter';
import FLoadingTip from '@/components/FLoadingTip';
import FNoDataTip from '@/components/FNoDataTip';
import FOverflowTooltip from '@/components/FOverflowTooltip';
import FFileTypeIcon from '@/components/FFileTypeIcon';
import FSelect2 from '@/components/FSelect2';
import FInput_Search from '@/components/FInput_Search';

interface FObjectSelectorProps {
  selectedObjectIDs: string[];

  onSelect?({ id, name }: { id: string; name: string }): void;

  onDelete?({ id, name }: { id: string; name: string }): void;
}

interface FObjectSelectorStates {
  selectOptions: { label: string; value: string }[];

  objectList: {
    objectId: string;
    bucketName: string;
    objectName: string;
    resourceType: string[];
    updateDate: string;
    mime: string;
  }[];
  oTotal: number;
  oSelect: '_all' | string;
  oInput: string;
}

const initStates: FObjectSelectorStates = {
  selectOptions: [{ label: '全部Bucket', value: '_all' }],
  objectList: [],
  oTotal: -1,
  oSelect: '_all',
  oInput: '',
};

function FObjectSelector({ selectedObjectIDs, onSelect, onDelete }: FObjectSelectorProps) {
  const [$state, $setState] = AHooks.useSetState<FObjectSelectorStates>(initStates);

  const [$showDeleteResourceID, set$showDeleteResourceID, get$showDeleteResourceID] =
    FUtil.Hook.useGetState<string>('');

  const [$listState, set$listState, get$listState] = FUtil.Hook.useGetState<
    'loading' | 'noData' | 'noSearchResult' | 'loaded'
  >('loading');
  const [$listMore, set$listMore, get$listMore] = FUtil.Hook.useGetState<
    'loading' | 'andMore' | 'noMore'
  >('loading');

  AHooks.useMount(async () => {
    fetchObjects(true);

    const params: Parameters<typeof FServiceAPI.Storage.bucketList>[0] = {
      // bucketType: 0,
      bucketType: 1,
    };
    const {
      data,
    }: {
      data: any[];
    } = await FServiceAPI.Storage.bucketList(params);

    $setState({
      selectOptions: [
        ...$state.selectOptions,
        ...data.map((b) => {
          return {
            label: b.bucketName,
            value: b.bucketName,
          };
        }),
      ],
    });
  });

  AHooks.useUnmount(() => {});

  const { run } = AHooks.useDebounceFn(
    () => {
      fetchObjects(true);
    },
    {
      wait: 300,
    },
  );

  async function fetchObjects(restart: boolean) {
    let objectListData: FObjectSelectorStates['objectList'] = [];

    if (!restart) {
      objectListData = $state.objectList;
      set$listMore('loading');
    } else {
      set$listState('loading');
    }

    const params: Parameters<typeof FServiceAPI.Storage.objectList>[0] = {
      bucketName: $state.oSelect,
      isLoadingTypeless: 1,
      keywords: $state.oInput,
      skip: objectListData.length,
      limit: FUtil.Predefined.pageSize,
      // extNames: ''
    };
    const {
      data: data_objectList,
    }: {
      data: {
        totalItem: number;
        dataList: {
          objectId: string;
          bucketName: string;
          objectName: string;
          resourceType: string[];
          updateDate: string;
          // mime: string;
          systemProperty: {
            mime: string;
          };
        }[];
      };
    } = await FServiceAPI.Storage.objectList(params);

    const objectList: FObjectSelectorStates['objectList'] = [
      ...objectListData,
      ...data_objectList.dataList.map<FObjectSelectorStates['objectList'][number]>((o) => ({
        objectId: o.objectId,
        bucketName: o.bucketName,
        objectName: o.objectName,
        resourceType: o.resourceType,
        updateDate: FUtil.Format.formatDateTime(o.updateDate, true),
        mime: o.systemProperty?.mime || '',
      })),
    ];

    const { state, more } = listStateAndListMore({
      list_Length: objectList.length,
      total_Length: data_objectList.totalItem,
      has_FilterCriteria: $state.oInput !== '',
    });

    set$listState(state);
    set$listMore(more);

    $setState({
      oTotal: data_objectList.totalItem,
      objectList,
    });
  }

  return (
    <>
      <div style={{ height: 30 }} />
      <div className={styles.filter}>
        {/* <FDropdownMenu
          options={$state.selectOptions}
          onChange={(value) => {
            $setState({
              oSelect: value,
            });
            run();
          }}
          text={$state.selectOptions.find((rs) => rs.value === $state.oSelect)?.text || ''}
        /> */}
        <FSelect2
          style={{ width: 120 }}
          options={$state.selectOptions}
          value={$state.oSelect}
          onChange={(value) => {
            $setState({
              oSelect: value,
            });
            run();
          }}
        />
        {/* <FComponentsLib.FInput.FSearch */}
        <FInput_Search
          value={$state.oInput}
          onChange={(e) => {
            $setState({
              oInput: e.target.value,
            });
            run();
          }}
        />
      </div>
      <div style={{ height: 30 }} />

      {$listState === 'loading' && <FLoadingTip height={600} />}

      {$listState === 'noData' && <FNoDataTip height={600} tipText={'无数据'} />}

      {$listState === 'noSearchResult' && <FNoDataTip height={600} tipText={'无搜索结果'} />}

      {$listState === 'loaded' && (
        <>
          <div className={styles.list}>
            {$state.objectList.map((o) => {
              return (
                <div
                  key={o.objectId}
                  className={styles.itemCard}
                  onMouseEnter={() => {
                    if (selectedObjectIDs.includes(o.objectId)) {
                      set$showDeleteResourceID(o.objectId);
                    }
                  }}
                  onMouseLeave={() => {
                    set$showDeleteResourceID('');
                  }}
                >
                  <div
                    className={styles.itemCard_item}
                    onClick={() => {
                      if (!selectedObjectIDs.includes(o.objectId)) {
                        onSelect?.({ id: o.objectId, name: `${o.bucketName}/${o.objectName}` });
                      }
                    }}
                  >
                    <div className={styles.itemCard_item_content}>
                      <FFileTypeIcon mime={o.mime} style={{ width: 30 }} />
                      <div>
                        {/* <FComponentsLib.FContentText
                          text={`${o.bucketName}/${o.objectName}`}
                          type={'highlight'}
                          style={{
                            maxWidth: 350,
                          }}
                          singleRow
                        /> */}
                        <FOverflowTooltip
                          text={`${o.bucketName}/${o.objectName}`}
                          style={{
                            maxWidth: 430,
                            color: '#222',
                            fontSize: '14px',
                            lineHeight: '20px',
                            fontWeight: '600',
                          }}
                        />
                        <div style={{ height: 4 }} />
                        <div className={styles.itemCard_item_content_info}>
                          {/* <FComponentsLib.FContentText
                            text={`更新时间 ${o.updateDate}`}
                            type={'additional2'}
                            style={{
                              maxWidth: 340,
                            }}
                            singleRow
                          /> */}
                          <FOverflowTooltip
                            text={`更新时间 ${o.updateDate}`}
                            style={{
                              maxWidth: 430,
                              flexShrink: 1,
                              lineHeight: '18px',
                              color: '#999',
                              fontSize: '12px',
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {selectedObjectIDs.includes(o.objectId) && (
                      <label className={styles.itemCard_item_selectedLabel}>
                        <FIcons.FCheck style={{ fontSize: 14, color: '#2784FF' }} />
                        <span>已添加</span>
                      </label>
                    )}

                    {/*{*/}
                    {/*  (!selectedObjectIDs.includes(o.objectId))*/}
                    {/*    ? (<FComponentsLib.FRectBtn*/}
                    {/*      type='secondary'*/}
                    {/*      size='small'*/}
                    {/*      onClick={() => {*/}
                    {/*        onSelect && onSelect({ id: o.objectId, name: `${o.bucketName}/${o.objectName}` });*/}
                    {/*      }}*/}
                    {/*      // disabled={!i.latestVersion}*/}
                    {/*    >选择</FComponentsLib.FRectBtn>)*/}
                    {/*    : (<FComponentsLib.FRectBtn*/}
                    {/*      type='danger2'*/}
                    {/*      size='small'*/}
                    {/*      onClick={() => {*/}
                    {/*        onDelete && onDelete({ id: o.objectId, name: `${o.bucketName}/${o.objectName}` });*/}
                    {/*      }}*/}
                    {/*      // disabled={disabledIDsOrNames?.includes(i.title) || disabledIDsOrNames?.includes(i.id)}*/}
                    {/*    >移除</FComponentsLib.FRectBtn>)*/}
                    {/*}*/}
                  </div>

                  {$showDeleteResourceID === o.objectId && (
                    <div
                      className={styles.itemCard_deleteButton}
                      onClick={() => {
                        onDelete?.({ id: o.objectId, name: `${o.bucketName}/${o.objectName}` });
                        set$showDeleteResourceID('');
                      }}
                    >
                      移除
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <FListFooter
            state={$listMore}
            onClickLoadMore={() => {
              fetchObjects(false);
            }}
          />
        </>
      )}

      {/*<FResourceList*/}
      {/*  disabledIDsOrNames={disabledIDsOrNames}*/}
      {/*  showRemoveIDsOrNames={showRemoveIDsOrNames}*/}
      {/*  resourceObjects={$state.objectList.map<FResourceListProps['resourceObjects'][number]>((o) => ({*/}
      {/*    id: o.objectId,*/}
      {/*    resourceType: o.resourceType,*/}
      {/*    status: 1,*/}
      {/*    time: o.updateDate,*/}
      {/*    title: `${o.bucketName}/${o.objectName}`,*/}
      {/*    latestVersion: '0.0.0',*/}
      {/*  }))}*/}
      {/*  loading={$state.oTotal === -1}*/}
      {/*  stillMore={$state.oTotal > $state.objectList.length}*/}
      {/*  onSelect={(value) => {*/}
      {/*    onSelect && onSelect({ id: value.id, name: value.title });*/}
      {/*  }}*/}
      {/*  onDelete={(value) => {*/}
      {/*    onDelete && onDelete({ id: value.id, name: value.title });*/}
      {/*  }}*/}
      {/*  onLoadMord={() => {*/}
      {/*    fetchObjects(false);*/}
      {/*  }}*/}
      {/*/>*/}
    </>
  );
}

export default FObjectSelector;
